
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'

export const STPPreventiveMachineryOperationExportData = (props) => {
    const { ExcelData, name, Date } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '45%' }}>

                <h5><span>&emsp;</span></h5>

                {/* <h4 style={{ textAlign: 'center', fontSize: 16 }}>Navi Mumbai Muncipal Corporation</h4>
                <h4 style={{ textAlign: 'center', fontSize: 16 }}>STP Maintenance Department</h4>
                <h4 style={{ textAlign: 'center', fontSize: 16 }}>Project Name - {ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table[0].projectName : '-'}</h4>
                <h4 style={{ textAlign: 'center', fontSize: 16 }}>Report Name - {name}</h4>
                <h4 style={{ textAlign: 'center', fontSize: 16 }}>Report Date - {Date ? moment(Date).format('DD-MM-YYYY') : '-'}</h4> */}

                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16 }}>Navi Mumbai Muncipal Corporation</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16 }}>STP Maintenance Department</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16 }}>
                        Project Name - {ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table[0].projectName : '-'}
                    </th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16 }}>Report Name - {name}</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16 }}>
                        Report Date - {Date ? moment(Date).format('DD-MM-YYYY') : '-'}
                    </th>
                </tr>
                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th className="sr_no_col" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                        <th>Reading Date</th>
                        <th>Unit Type</th>
                        <th>Equipment Type </th>
                        <th>Equipment Details </th>
                        <th>Operation Hours </th>
                        <th style={{ borderRight: "1px solid black" }}>Current Amp</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                            return (
                                <tr style={{ width: '100%', border: "1px solid black" }}>
                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.unitType ? item.unitType : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.equipmentType ? item.equipmentType : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.equipmentDetails ? item.equipmentDetails : '-'}</td>
                                    <td style={{ textAlign: "right" }} itemType="string" >{item.operationHours != 0.0 ? item.operationHours.toFixed(2) : '0.0'}</td>
                                    <td style={{ textAlign: "right" }}>{item.currentAmp != 0.0 ? item.currentAmp.toFixed(2) : '0.0'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>
            </table>
        </div>
    )
}